import { Button } from "@mui/material";
import React from "react";

export default function PrimarySmallBlueButton({
  startIcon,
  buttonTitle,
  onClick,
  width,
  endIcon
}) {
  return (
    <>
      <Button
        variant="contained"
        startIcon={startIcon ? startIcon : ""}
        onClick={onClick}
        endIcon={endIcon}
        sx={{
          borderRadius: "8px",
          fontSize: "14px",
          fontWeight: 600,
          textTransform: "none",
          backgroundColor: "#572575",
          width: { width },
// height:30,
          "&:hover": {
            backgroundColor: "#4A1E66",
          },
        }}
      >
        {buttonTitle}
      </Button>
    </>
  );
}
